import { IKeyLabelPair, ValidationStatus } from './mfe-common.interfaces';

export interface FinancialsGetData {
  selectedIncome: IKeyLabelPair;
  selectedNetworth: IKeyLabelPair;
  validationStatus: ValidationStatus;
}
